<template>
  <div style="overflow: hidden">
    <Loading1 v-if="vLoading" />
    <v-row class="d-flex justify-center">
      <v-col cols="12" md="11">
        <v-card class="common-card">
          <v-card-text>
            <div class="d-flex justify-center">
              <div
                class="me-3 d-flex flex-wrap justify-center pointer"
                @click="$router.push('/checkout/cart')"
              >
                <v-icon
                  class="me-3 dark-icon"
                  small
                  style="transform: scaleX(-1)"
                  >$SmallShopCart</v-icon
                >
                <span class="mt-1">سبد خرید</span>
              </div>
              <div class="connectedLine"></div>
              <div class="ms-3 d-flex flex-wrap justify-center">
                <v-icon class="me-3 shopPrimary--text orange-icon"
                  >$Truck</v-icon
                >
                <span class="shopPrimary--text mt-1 ms-3">اطلاعات و ارسال</span>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!--address-->
    <v-row class="d-flex mt-2 justify-center">
      <v-col cols="12" md="7">
        <div>
          <v-card class="common-card">
            <v-card-text>
              <div class="d-flex justify-content-between mb-3">
                <span class="c-grey" style="font-size: 12px"
                  >آدرس تحویل سفارش</span
                >
                <span
                  @click="editAddress()"
                  class="font-weight-bold shopPrimary--text pointer"
                  >{{ !computedSubmit ? "ویرایش آدرس" : "تکمیل آدرس" }}
                  <v-icon small class="shopPrimary--text orange-icon ms-1"
                    >$Edit</v-icon
                  ></span
                >
              </div>
              <div>
                <v-icon>$Location</v-icon>
                <span class="ms-1 black--text font-weight-bold">
                  <span v-if="user.stateName">{{ user.stateName }}، </span>
                  <span v-if="user.cityName">{{ user.cityName }}،</span>
                  <span v-if="user.district">
                    {{
                      user.cityName == "تهران" ? `منطقه ${user.district}` : ""
                    }}،
                  </span>
                  {{ user.address }}
                </span>
                <p class="ms-1 mt-4 font-weight-bold c-grey">{{ user.name }}</p>
              </div>
            </v-card-text>
          </v-card>
        </div>
        <div class="mt-4">
          <v-card class="common-card">
            <div class="mb-6">
              <p class="c-grey font-weight-bold ms-1">سفارش‌ها:</p>
            </div>
            <v-card
              v-for="(item, index) in wares.details"
              :key="index"
              class="d-flex ms-10 me-10 mt-2 mb-3 common-card"
              style="background-color: #eee !important"
            >
              <v-row>
                <v-col cols="12" md="4" class="d-flex justify-center">
                  <img
                    :src="item.pictureUrl ? item.pictureUrl : '/no-image.png'"
                    class="stuff-image"
                  />
                </v-col>
                <v-col cols="12" md="5" class="text-center">
                  <div class="mt-0 mt-sm-4 ms-0 ms-sm-6">
                    <span>{{ item.name }}</span>
                  </div>
                </v-col>
                <v-col cols="12" md="3" class="text-center">
                  <div class="mt-0 mt-sm-4">
                    <div v-if="item.discountedPrice">
                      <del class="red--text">
                        {{ item.price ? item.price.toLocaleString() : 0 }}
                        تومان
                      </del>
                      <div
                        class="mx-auto d-flex my-2 justify-center align-center text-center"
                        style="
                          border-radius: 50%;
                          background-color: #ef5350 !important ;
                          width: 24px;
                          height: 24px;
                          font-size: 10px;
                        "
                      >
                        <span class="white--text text-center"
                          >{{
                            100 - (item.discountedPrice / item.price) * 100
                          }}%</span
                        >
                      </div>
                      <p>
                        {{
                          item.price ? item.discountedPrice.toLocaleString() : 0
                        }}
                        تومان
                      </p>
                    </div>
                    <div v-else>
                      <p>
                        {{ item.price ? item.price.toLocaleString() : 0 }}
                        تومان
                      </p>
                    </div>
                  </div>
                  <div class="d-flex mt-0 mt-sm-5 mb-2 justify-center">
                    <div class="d-flex">
                      <span class="fs-medium count py-1 px-3 c-grey">
                        تعداد: {{ item.amount }}
                      </span>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-card>
        </div>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="common-card">
          <div v-if="editLoading" class="text-center">
            <looping-rhombuses-spinner
              :animation-duration="2500"
              :rhombus-size="15"
              color="#EF6C00"
              class="mx-auto my-10"
            />
          </div>
          <v-card-text v-else>
            <div class="d-flex flex-sm-row align-center justify-center">
              <p class="fs-medium mainFont--text">جمع سبد خرید:</p>
              <p class="fs-medium mainFont--text ms-1">
                <span v-show="false">{{ reactivity }}</span>
                {{ Number(computedTotalCost()).toLocaleString() }}
                تومان
              </p>
            </div>
            <div class="d-flex flex-sm-row align-center justify-center">
              <p class="fs-medium mainFont--text">هزینه‌ی حمل:</p>
              <p class="fs-medium mainFont--text ms-1">
                <span v-show="false">{{ reactivity }}</span>
                {{
                  shippingFinalCost != 0
                    ? Number(shippingFinalCost).toLocaleString() + " تومان"
                    : "رایگان"
                }}
              </p>
            </div>
            <div class="d-flex flex-sm-row align-center justify-center">
              <p class="fs-medium mainFont--text">اعتبار:</p>
              <p class="fs-medium mainFont--text ms-1">
                <span v-show="false">{{ reactivity }}</span>
                {{ Number(userCredit).toLocaleString() }} تومان
              </p>
            </div>
            <div v-if="userCredit" class="text-center text-lg-right">
              <span @click="useRoyaltyCredit = true" v-if="!useRoyaltyCredit">
                <v-icon class="shopPrimary--text">
                  mdi-checkbox-blank-outline
                </v-icon>
              </span>
              <span v-else @click="useRoyaltyCredit = false">
                <v-icon class="shopPrimary--text">
                  mdi-checkbox-marked-outline
                </v-icon>
              </span>
              <span> در این خرید از اعتبار استفاده می‌کنم </span>
            </div>
            <div
              class="d-flex flex-wrap flex-column flex-sm-row align-center justify-sm-space-between mt-5"
            >
              <p class="fs-large" style="color: #ff5400">مبلغ قابل پرداخت</p>
              <p class="fs-large" style="color: #ff5400">
                {{ Number(computedFinalTotalCost()).toLocaleString() }}
                تومان
              </p>
            </div>

            <p
              v-if="computedSubmit"
              class="red--text text-center mt-4"
              style="font-size: 14px"
            >
              لطفا آدرس ارسال و مشخصات خود را به طور کامل وارد نمایید
            </p>
            <div class="w-100 text-left">
              <v-btn
                class="shopPrimary white--text w-100"
                @click="submitPurchase()"
                :loading="submitLoading"
                :disabled="computedSubmit"
              >
                <template v-slot:loader>
                  <looping-rhombuses-spinner
                    :animation-duration="2500"
                    :rhombus-size="15"
                    color="#fff"
                    class="mx-auto my-10"
                  />
                </template>
                <span v-if="computedFinalTotalCost()"> پرداخت </span>
                <span v-else> ثبت نهایی</span></v-btn
              >
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="editInforamtion" width="500">
      <!--wares-->
      <v-row class="d-flex justify-center mb-4">
        <span v-show="false">{{ reactivity }}</span>
        <v-col cols="12" md="7">
          <v-card class="common-card">
            <div class="mb-6">
              <p class="c-grey font-weight-bold ms-1">سفارش‌ها:</p>
            </div>
            <v-card
              v-for="(item, index) in wares"
              :key="index"
              class="d-flex me-10 ms-10 mt-2 mb-3 common-card"
              style="background-color: #eee !important"
            >
              <v-row>
                <v-col cols="12" md="4" class="d-flex justify-center">
                  <img :src="item.imageUrl" class="stuff-image" />
                </v-col>
                <v-col cols="12" md="5" class="text-center">
                  <div class="mt-0 mt-sm-4 ms-0 ms-sm-6">
                    <span>{{ item.title }}</span>
                  </div>
                </v-col>
                <v-col cols="12" md="3" class="text-center">
                  <div class="mt-0 mt-sm-4">
                    <div v-if="item.priceAfterDiscount != item.originalPrice">
                      <p>
                        {{
                          item.priceAfterDiscount
                            ? item.priceAfterDiscount.toLocaleString()
                            : 0
                        }}
                        تومان
                      </p>
                    </div>
                    <div v-else>
                      <p>
                        {{
                          item.originalPrice
                            ? item.originalPrice.toLocaleString()
                            : 0
                        }}
                        تومان
                      </p>
                    </div>
                  </div>
                  <div class="d-flex mt-0 mt-sm-5 mb-2 justify-center">
                    <div class="d-flex">
                      <span class="fs-medium count py-1 px-3 c-grey">
                        تعداد: {{ item.number }}
                      </span>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-card>
        </v-col>
        <v-col cols="4"></v-col>
      </v-row>
    </v-dialog>
    <v-dialog v-model="editInforamtion" width="600">
      <v-card>
        <v-card-title
          class="white shopPrimary--text d-flex justify-content-between"
        >
          <span> اطلاعات آدرس </span>
          <span>
            <v-icon
              class="shopPrimary--text orange-icon mt-2"
              @click="editInforamtion = false"
              >$Close</v-icon
            >
          </span>
        </v-card-title>
        <hr />
        <v-card-text v-if="!changeAddress">
          <div
            class="pointer d-flex justify-content-between"
            @click="changeAddress = true"
          >
            <div>
              <span>
                <v-icon small class="me-1 ms-1 black--text font-weight-bold"
                  >$Edit</v-icon
                >
              </span>
              <span class="black--text font-weight-bold ms-3">ویرایش آدرس</span>
            </div>
            <div>
              <v-icon small class="black--text font-weight-bold dark-icon me-2"
                >$ChevronLeft</v-icon
              >
            </div>
          </div>
          <hr />
          <div v-if="editLoading" class="text-center">
            <looping-rhombuses-spinner
              :animation-duration="2500"
              :rhombus-size="15"
              color="#EF6C00"
              class="mx-auto my-10"
            />
          </div>
          <div v-else>
            <div class="my-5">
              <span v-show="false">{{ reactivity }}</span>
              <span><v-icon class="ms-1">$BlackLocation</v-icon></span>
              <span class="ms-2 mainFont--text">
                <span v-if="user.stateName">{{ user.stateName }}، </span>
                <span v-if="user.cityName">{{ user.cityName }}،</span>
                <span v-if="user.district">
                  {{
                    user.cityName == "تهران" ? `منطقه ${user.district}` : ""
                  }}،
                </span>
                {{ user.address }}
              </span>
            </div>
            <div class="my-5">
              <span><v-icon small class="mb-2 ms-1">$Email</v-icon></span>
              <span class="ms-4 mainFont--text">{{
                user.postalCode ? user.postalCode : "--"
              }}</span>
            </div>
            <div class="my-5">
              <span><v-icon small class="mb-3">$Phone</v-icon></span>
              <span class="ms-5 mainFont--text">{{ user.mobile }}</span>
            </div>
            <div class="my-5">
              <span><v-icon class="mb-2">$BigUser</v-icon></span>
              <span class="ms-3 mainFont--text">{{ user.name }}</span>
            </div>
          </div>
        </v-card-text>
        <v-card-text v-else>
          <div>
            <div class="mt-4">
              <v-row class="d-flex flex-row mt-3">
                <v-col cols="12">
                  <v-autocomplete
                    v-model.trim="editUser.stateId"
                    :items="states"
                    label=" استان*"
                    outlined
                    dense
                    item-text="name"
                    item-value="id"
                    no-data-text="موردی یافت نشد."
                    hide-details
                    @input="getCities()"
                    :loading="stateLoading"
                  >
                  </v-autocomplete
                ></v-col>
                <v-col cols="12" v-if="editUser.stateId">
                  <v-autocomplete
                    v-model.trim="editUser.cityId"
                    :items="cities"
                    label="شهر*"
                    outlined
                    dense
                    item-text="name"
                    item-value="id"
                    no-data-text="موردی یافت نشد."
                    hide-details
                    @change="cityChange()"
                    :loading="cityLoading"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  v-if="editUser.cityName == 'تهران' && editUser.cityId != ''"
                >
                  <v-autocomplete
                    v-model.trim="editUser.district"
                    :items="districts"
                    outlined
                    dense
                    item-text="name"
                    item-value="id"
                    prefix="منطقه"
                    no-data-text="موردی یافت نشد."
                    hide-details
                    @change="reactivity = !reactivity"
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    label="آدرس*"
                    dense
                    outlined
                    hide-details
                    v-model="editUser.address"
                    @change="reactivity = !reactivity"
                  >
                  </v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    label="کد پستی*"
                    dense
                    outlined
                    hide-details
                    v-model="editUser.postalCode"
                    @change="reactivity = !reactivity"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="نام گیرنده*"
                    dense
                    outlined
                    hide-details
                    v-model="editUser.name"
                    @change="reactivity = !reactivity"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </div>
          </div>
          <div
            class="text-sm-left text-right mt-4 d-flex flex-sm-row flex-column justify-content-between"
          >
            <div>
              <v-btn
                class="shopPrimary white--text me-1 mb-sm-0 mb-4"
                @click="submitNewAddress()"
                >ذخیره آدرس در حساب کاربری</v-btn
              >
              <v-btn
                class="white--text mb-sm-0 mb-4"
                style="background-color: #37474f"
                @click="submitOptionalAddress()"
                >تغییرات را فقط برای این سفارش اعمال کن</v-btn
              >
            </div>
            <div>
              <v-btn
                class="ms-2 orange-borderedBtn"
                @click="changeAddress = false"
                >بازگشت</v-btn
              >
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Axios from "axios";
import { LoopingRhombusesSpinner } from "epic-spinners";
import { EventBus } from "./../../event-bus.js";

export default {
  components: {
    LoopingRhombusesSpinner,
  },
  data() {
    return {
      vLoading: false,
      editInforamtion: false,
      changeAddress: false,
      useRoyaltyCredit: false,
      invoiceId: "",
      newAddress: "",
      wares: [],
      user: {
        stateId: "",
        stateName: "",
        cityId: "",
        cityName: "",
        address: "",
        postalCode: "",
        name: "",
        district: "",
      },
      editUser: {
        stateId: "",
        cityId: "",
        address: "",
        postalCode: "",
        name: "",
        district: "",
        stateName: "",
        cityName: "",
      },
      reactivity: false,
      submitLoading: false,
      reactivity: false,
      states: [],
      cities: [],
      districts: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22,
      ],
      stateLoading: false,
      cityLoading: false,
      isUserAddressCompleted: false,
      userCredit: 0,
      shippingAddress: {},
      editLoading: false,
      shippingCosts: {},
      shippingFinalCost: null,
    };
  },
  methods: {
    cityChange() {
      this.reactivity = !this.reactivity;
      this.editUser.cityName = this.cities.filter(
        (city) => city.id == this.editUser.cityId
      )[0].name;
    },
    getDataLocalStorage() {
      this.user.id = localStorage.getItem("id");
      this.user.mobile = localStorage.getItem("mobile");
      this.user.name = localStorage.getItem("name");
      this.shippingAddress = JSON.parse(
        localStorage.getItem("shippingAddress")
      );
      this.shippingCosts = JSON.parse(localStorage.getItem("shippingCost"));

      this.user.address = this.shippingAddress.address;
      this.user.postalCode = this.shippingAddress.postalCode;
      this.user.stateId = this.shippingAddress.stateId;
      this.user.stateName = this.shippingAddress.stateName;
      this.editUser = JSON.parse(JSON.stringify(this.user));
      if (this.user && this.user.stateId) {
        this.getCities();
        this.user.cityId = this.shippingAddress.cityId;
        this.user.cityName = this.shippingAddress.cityName;
        if (this.user.cityName == "تهران") {
          this.user.district = this.shippingAddress.district;
        }
      }
      this.editUser = JSON.parse(JSON.stringify(this.user));
      this.isUserAddressCompleted = localStorage.getItem(
        "isUserAddressCompleted"
      );
      this.userCredit = localStorage.getItem("userCredit");
    },
    editAddress() {
      this.editUser = JSON.parse(JSON.stringify(this.user));
      this.editInforamtion = true;
      this.changeAddress = false;
    },
    setShippingCost() {
      let districtPrice = 0;
      if (this.editUser.cityName == "تهران") {
        districtPrice = this.setShippingCost
          ? this.shippingCosts.tehranShippingCost.filter(
              (cost) => cost.district == this.editUser.district
            )[0].price
          : 0;
      } else {
        districtPrice = 50000;
      }
      if (this.computedTotalCost() > this.shippingCosts.freeShippingCost) {
        districtPrice = 0;
      }
      this.reactivity = !this.reactivity;
      this.shippingFinalCost = districtPrice;
    },
    submitOptionalAddress() {
      this.editInforamtion = false;
      this.editLoading = true;
      setTimeout(() => {
        this.setShippingCost();
        this.user = this.editUser;
        this.editUser.stateName = this.states.filter(
          (state) => state.id == this.editUser.stateId
        )[0]
          ? (this.editUser.stateName = this.states.filter(
              (state) => state.id == this.editUser.stateId
            )[0].name)
          : "";
        this.editUser.cityName = this.cities.filter(
          (city) => city.id == this.editUser.cityId
        )[0]
          ? this.cities.filter((city) => city.id == this.editUser.cityId)[0]
              .name
          : "";
        this.editLoading = false;
      }, 1000);
    },
    submitNewAddress() {
      this.changeAddress = false;
      this.editLoading = true;
      Axios.patch(
        this.baseUrl + "/onlineShop/user/edit",
        {
          name: this.editUser.name,
          stateId: this.editUser.stateId ? this.editUser.stateId : undefined,
          cityId: this.editUser.cityId ? this.editUser.cityId : undefined,
          district:
            this.editUser.cityName == "تهران"
              ? Number(this.editUser.district)
              : undefined,
          address: this.editUser.address,
          postalCode: this.editUser.postalCode,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            setTimeout(() => {
              this.editLoading = false;
              this.editUser.stateName = this.states.filter(
                (state) => state.id == this.editUser.stateId
              )[0]
                ? this.states.filter(
                    (state) => state.id == this.editUser.stateId
                  )[0].name
                : "";
              this.editUser.cityName = this.cities.filter(
                (city) => city.id == this.editUser.cityId
              )[0]
                ? this.cities.filter(
                    (city) => city.id == this.editUser.cityId
                  )[0].name
                : "";
              this.user = JSON.parse(JSON.stringify(this.editUser));
              localStorage.setItem("name", this.editUser.name);
              localStorage.setItem("postalCode", this.editUser.postalCode);
              localStorage.setItem("address", this.editUser.address);
              EventBus.$emit("updateInfo");
              this.setShippingCost();
              this.reactivity = !this.reactivity;
            }, 1000);
          }
        })
        .catch((err) => {
          this.editLoading = false;
        });
    },
    getSelectedWares() {
      this.wares.details = JSON.parse(localStorage.getItem("cart"));
      this.wares.itemIds = this.wares.details.map((detail) => detail.id);
      this.setShippingCost();
      this.reactivity = !this.reactivity;
    },
    getState() {
      this.stateLoading = true;
      Axios.get(this.baseUrl + "/onlineShop/states/list", {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("shopToken"),
        },
      })
        .then((res) => {
          if (res.status == 200) {
            this.stateLoading = false;
            this.states = res.data;
          }
        })
        .catch((err) => {
          this.stateLoading = false;
        });
    },
    getCities() {
      this.cityLoading = true;
      this.editUser.cityId = "";
      if (this.editUser.stateId) {
        Axios.get(
          this.baseUrl + "/onlineShop/cities/getData/" + this.editUser.stateId,
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("shopToken"),
            },
          }
        )
          .then((res) => {
            if (res.status == 200) {
              this.cityLoading = false;
              this.cities = res.data;
              this.reactivity = !this.reactivity;
            }
          })
          .catch((err) => {
            this.cityLoading = false;
          });
      }
    },
    submitPurchase() {
      this.submitLoading = true;
      this.vLoading = true;
      let totalCost = this.wares.details
        .map((ware) =>
          ware.discountedPrice
            ? ware.discountedPrice * ware.amount
            : ware.price * ware.amount
        )
        .reduce((a, b) => a + b, 0);

      this.wares.details.map(
        (w) => (w.price = w.discountedPrice ? w.discountedPrice : w.price)
      );
      this.wares.details.forEach((detail) => {
        delete detail.discountedPrice;
      });
      // if (
      //   this.useRoyaltyCredit &&
      //   this.userCredit >= computedFinalTotalCost()
      // ) {
      //   this.$router.push("/successfulpurchase");
      // }
      Axios.post(
        this.baseUrl + "/onlineShop/cart/finalize",
        {
          id: this.user.id,
          name: this.editUser.name,
          address: this.editUser.address,
          totalCost: this.useRoyaltyCredit
            ? totalCost - Number(this.userCredit) >= 0
              ? totalCost - Number(this.userCredit)
              : 0
            : totalCost,
          postalCode: this.editUser.postalCode,
          cityId: this.editUser.cityId,
          stateId: this.editUser.stateId,
          district:
            this.editUser.cityName == "تهران"
              ? Number(this.editUser.district)
              : undefined,
          details: this.wares.details,
          itemIds: this.wares.itemIds,
          useRoyaltyCredit: this.useRoyaltyCredit,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.invoiceId = res.data.id;
            localStorage.setItem("purchaseId", res.data.id);
            localStorage.setItem("invoiceCode", res.data.invoiceCode);
            this.goToPort();
          }
        })
        .catch((err) => {
          if (err.response.status == 409) {
            this.$router.push("/checkout/cart");
            localStorage.setItem(
              "cart",
              JSON.stringify(
                err.response.data.details.filter((detail) => detail.sum != 0)
              )
            );
            let outOfStock = err.response.data.details
              .filter((detail) => detail.sum == 0)
              .map((detail) => detail.name);
            localStorage.setItem("outOfStock", JSON.stringify(outOfStock));
            this.toast(err.response.data.message, "error");
          } else {
            this.toast(err.response.data, "error");
          }
          this.submitLoading = false;
        });
    },
    goToPort() {
      Axios.post(
        this.baseUrl +
          "/onlineShop/payment/createTransactionToken/" +
          this.invoiceId,
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.submitLoading = false;
            // this.vLoading = false;
            let link = document.createElement("a");
            link.setAttribute("href", res.data);
            link.click();
          } else if (res.status == 201) {
            // this.vLoading = false;
            this.submitLoading = false;
            this.$router.push("/successfulpurchase");
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    computedTotalCost() {
      let totalCost;
      if (this.wares && this.wares.details) {
        totalCost = this.wares.details
          .map((ware) =>
            ware.discountedPrice
              ? ware.discountedPrice * ware.amount
              : ware.price * ware.amount
          )
          .reduce((a, b) => a + b, 0);
      }
      return totalCost;
    },
    computedFinalTotalCost() {
      let finalTotalCost;
      finalTotalCost = this.useRoyaltyCredit
        ? this.computedTotalCost() +
            Number(this.shippingFinalCost) -
            Number(this.userCredit) >=
          0
          ? this.computedTotalCost() +
            Number(this.shippingFinalCost) -
            Number(this.userCredit)
          : 0
        : this.computedTotalCost() + Number(this.shippingFinalCost);
      return finalTotalCost;
    },
  },
  computed: {
    computedSubmit() {
      let submit = false;

      submit =
        !this.user.stateId ||
        !this.user.cityId ||
        (this.user.cityName == "تهران" && !this.user.district) ||
        !this.user.address ||
        !this.user.postalCode ||
        !this.user.name;
      this.reactivity = !this.reactivity;
      return submit;
    },
  },
  mounted() {
    this.getState();
    this.getDataLocalStorage();
    this.getSelectedWares();
    if (!window.localStorage.getItem("shopToken")) {
      this.$router.push("/");
    }
  },
};
</script>

<style lang="scss">
.ipad-card {
  @media only screen and (min-width: 600px) and (max-width: 1300px) {
    margin-top: 120px !important;
  }
}
.stuff-image {
  width: 60%;
  margin: 0 auto;
  border-radius: 10px;
}
.connectedLine {
  width: 100px !important;
  height: 2px !important;
  background-color: #909090;
  margin-top: 16px;
  @media screen and (max-width: 600px) {
    width: 40px !important;
  }
}
* {
  user-select: none;
}
</style>
